import { render, staticRenderFns } from "./ruletoorderdisassembly.vue?vue&type=template&id=ac5e31a6"
import script from "./ruletoorderdisassembly.vue?vue&type=script&lang=js"
export * from "./ruletoorderdisassembly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports